import React from 'react';

import { ContainedButton, OutlinedButton } from '../Buttons';
import Modal from '../Modal';
import styles from './CancelProcessModal.module.scss';

type TCancelProcessModal = {
  open: boolean;
  switchModal: () => void;
  cancelCallBack: () => void;
  cancelUpload: boolean;
  cancelAndClearLoading: () => void;
};

const CancelProcessModal: React.FC<TCancelProcessModal> = ({ open, switchModal, cancelCallBack, cancelUpload, cancelAndClearLoading }) => {
  const onModalClose = () => {
    if (cancelUpload) return;
    switchModal();
  };

  const handleCancel = async () => {
    cancelCallBack();
  };

  return (
    <Modal open={open} onClose={onModalClose}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Are you sure you want to cancel this process?</div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <ContainedButton onClick={handleCancel} kind="red" disabled={cancelUpload}>
              Stop upload
            </ContainedButton>

            <ContainedButton onClick={cancelAndClearLoading} kind="red" disabled={cancelUpload}>
              Stop and delete upload
            </ContainedButton>

            <OutlinedButton kind="default" onClick={onModalClose} disabled={cancelUpload}>
              No
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CancelProcessModal;
